import { render } from "./jbh_NRPG.vue?vue&type=template&id=283985fa&scoped=true"
const script = {}

import "./jbh_NRPG.vue?vue&type=style&index=0&id=283985fa&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283985fa"],['__file',"src/views/jbh/jbh_NRPG.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "283985fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('283985fa', __exports__)) {
    console.log('reload')
    api.reload('283985fa', __exports__)
  }
  
  module.hot.accept("./jbh_NRPG.vue?vue&type=template&id=283985fa&scoped=true", () => {
    console.log('re-render')
    api.rerender('283985fa', render)
  })

}


export default __exports__